import { RouteParam } from "../../../routes";
import { MODULE, ACTION } from "../../../utils/enums";
import ProcurementLandingPage from "../landing_page";
import party_routes from "./party_routes";
import purchase_voucher_routes from "./purchase_voucher_routes";
import gst_routes from "./gst_routes";

const accounts_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: "/procurement",
    component: ProcurementLandingPage,
    module: MODULE.procurement_panel,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  ...party_routes,
  ...gst_routes,
  ...purchase_voucher_routes,
];

export default accounts_routes;
